import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { SessionInvitesStatus } from "@classview/shared-types";

import { useGetPendingSessions } from "../api/get-pending-sessions";
import { getOrgSessionStatus } from "../utils/get-org-session-status";

export function PendingSessionsCounter() {
  const { organisation } = useOrganisation();

  const { data, isSuccess } = useGetPendingSessions(
    {
      organisationId: organisation.id,
    },
    {
      select: (sessions) => {
        return sessions.filter(
          (session) =>
            getOrgSessionStatus({
              orgId: organisation.id,
              session,
            }) === SessionInvitesStatus.PENDING,
        );
      },
    },
  );

  if (!isSuccess) {
    return null;
  }

  const nbOfPendingSessions = data.length;

  return (
    <span className="flex size-5 items-center justify-center rounded-full border border-primary-200 text-xs font-medium">
      {nbOfPendingSessions}
    </span>
  );
}
